/**
 * @brief 공용모달
 * @details (임시로 만들어놈)
 * @author hyekyoungKang
 * @date 2024-06-14
 * @version 0.0.1
 */

import React from "react";
import "./CommonModal.scss";
import CommonButton from "../../common/buttons/CommonButton/CommonButton";
import { useModal } from "../../../context/Modal/ModalContext";

const CommonModal = ({
    children = "내용",
    isDispalyTwoMode,
    btnLeftTitle = "취소",
    btnRightTitle = "확인",
    btnTitle = "확인",
    btnWidth = "64px",
    btnHeight = "32px",
    btnFontSize = "14px",
    onClickButton,
    padding,
    style,
}) => {
    const { isOpen, closeModal } = useModal();

    if (!isOpen) return null;

    const handleButtonClick = () => {
        if (onClickButton) {
            onClickButton();
        }
        closeModal();
    };

    return (
        <div
            className="common-modal"
            style={{
                padding: padding ? padding : 0,
                style,
            }}
        >
            <div>{children}</div>
            {isDispalyTwoMode ? (
                <div className="common-modal-btns">
                    <CommonButton onClick={closeModal}>
                        {btnLeftTitle}
                    </CommonButton>
                    <CommonButton onClick={closeModal}>
                        {btnRightTitle}
                    </CommonButton>
                </div>
            ) : (
                <div className="common-modal-btns">
                    <CommonButton
                        color="black"
                        onClick={handleButtonClick}
                        style={{
                            width: btnWidth,
                            height: btnHeight,
                            fontSize: btnFontSize,
                        }}
                    >
                        {btnTitle}
                    </CommonButton>
                </div>
            )}
        </div>
    );
};

export default CommonModal;
